import { render } from "./BotonSoportesEmbargoPersonaComponent.vue?vue&type=template&id=42871a74"
import script from "./BotonSoportesEmbargoPersonaComponent.vue?vue&type=script&lang=js"
export * from "./BotonSoportesEmbargoPersonaComponent.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/tesoreria_tolima/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__